import { render } from "./CalendarEventAnnouncement.vue?vue&type=template&id=68e00519&scoped=true"
import script from "./CalendarEventAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CalendarEventAnnouncement.vue?vue&type=script&charset=utf-8&lang=js"

import "./CalendarEventAnnouncement.vue?vue&type=style&index=0&id=68e00519&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e00519"]])

export default __exports__